import { Layers } from "appworks/graphics/layers/layers";
import { StopOnWinToggleControl } from "appworks/ui/controls/standard/toggle/stop-on-win-toggle-control";
import { ControlFactory } from "../control-factory";

export class StopOnWinToggleControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiToggle("stop_on_any_win") != null;
    }

    public build(layer: Layers): StopOnWinToggleControl[] {
        return [new StopOnWinToggleControl(layer.getFlexiToggle("stop_on_any_win"))];
    }
}
